import { Component, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import * as _ from "lodash";
import { Subscription } from "rxjs";
import { FilterService } from "src/app/services/filter.service";
import { DeviceDetectionService } from "src/app/services/detectipad.service";
import { ConstantsService } from "src/app/services/constants.service";

@Component({
    selector: "app-patient-value-getter",
    template: `
    <button
      mat-raised-button
      color="primary"
      [style.background]="this.color"
      [style.color]="textColor"
      style="width: 80px;"
    >
      {{ this.valueFormatted }}
    </button>
  `,
    standalone: false
})
export class ValueBtnComponent implements ICellRendererAngularComp, OnDestroy {
  params: any;
  reqSubcription: Subscription[] = [];
  valueFormatted: any;
  color: any;
  textColor = "#fff";

  constructor(
    private dialog: MatDialog,
    public filterService: FilterService,
    private deviceDetectionService: DeviceDetectionService,
    private constantsService: ConstantsService
  ) {}

  agInit(params: ICellRendererParams<any>): void {
    this.params = params;
    const node = params.node;

    if (this.params.response) {
      let findIndex = this.params.response.rangeColorDynamic.findIndex(
        (o: any) => o.color == this.params["color"]
      );
      if (findIndex != -1 && findIndex > 4) {
        this.textColor = "#000";
      }
    }

    this.valueFormatted = this.params.valueFormatted || this.params.value;
    this.color = this.params["color"];
    const isGroup = params.node && params.node.group;

    if (isGroup&&this.params?.res?.ColorlinkColumnCondition) {
      const linkColumn = 'diff_ind'; // Or make this dynamic
      const children: any[] = node.allLeafChildren || [];
      // Create a flat array of all diff_ind values
      const indicators: string[] = children
        .map(child => child.data?.[linkColumn])
        .filter((val: string) => !!val);
      // console.log('Child indicators:', indicators);

      this.color= this.getDataForStringColor(this.params.res.conditionalFormatForString, params,this.params.res,indicators)
      // // Example: Decide color based on what values exist
      // if (indicators.includes('MISS_MATCH')) {
      //   this.color = '#1e88e5'; // blue
      // } else if (indicators.includes('POSITIVE')) {
      //   this.color = '#d50032'; // red
      // } else if (indicators.includes('NEGATIVE')) {
      //   this.color = '#fdd835'; // yellow
      // } else if (indicators.includes('NO_DIFF')) {
      //   this.color = '#32cd32'; // green
      // } else {
      //   this.color = '#ff6600'; // fallback color
      // }
    }
    
  }
  refresh(): boolean {
    return false;
  }
  getDataForStringColor(rangeValue: any[], param: any, res: any, value: any[]): string | null {
    if ((!rangeValue || rangeValue.length === 0) && value.length > 0) return null;
  
    const getColor = (key: string) => rangeValue.find(d => d.value === key)?.color;
  
    const hasValue = (val: string) => value.includes(val);
    const hasAll = (vals: string[]) => vals.every(val => value.includes(val));
  
    if (param?.value === 0 && hasAll(['POSITIVE', 'NEGATIVE'])) return getColor('MISS_MATCH');
    if (param?.value < 0) return getColor('NEGATIVE');
  
    const matched = rangeValue.find(r => hasValue(r.value));
    return matched?.color || '#ff6600';
  }
  
  ngOnDestroy() {
    this.reqSubcription.forEach((res: any) => res.unsubscribe());
  }
}